import styled from 'styled-components/macro';

import ModalBase from '@components/common/core/DataDisplay/Modal';
import TextBase from '@components/common/core/DataDisplay/Text';
import ButtonBase from '@components/common/core/Inputs/Button';
import TextField from '@components/common/core/Inputs/TextField';
import LabelBase from '@components/common/core/DataDisplay/Label';

export const Label = styled(LabelBase)``;

export const Input = styled(TextField)``;

export const ConnectProfileButton = styled(ButtonBase)`
  width: 100%;
  margin-top: 24px;
`;

export const ConnectedAt = styled(TextBase)`
  color: ${({ theme }) => theme.colors.gray[2]};
  font-size: 0.875rem;
`;

export const Name = styled(TextBase)`
  color: ${({ theme }) => theme.colors.gray[1]};
  font-size: 0.875rem;
`;

export const NotOperationalCredential = styled.div`
  padding: 8px 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const NotOperationalCredentialsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Description = styled(TextBase)`
  display: inline-block;
  color: ${({ theme }) => theme.colors.gray[1]};
  font-size: 1rem;
  margin-bottom: 16px;

  a {
    color: ${({ theme }) => theme.colors.gray[1]};
    text-decoration: underline;
    font-family: ${({ theme }) => theme.fonts.body};
  }
`;

export const Title = styled(TextBase)`
  color: ${({ theme }) => theme.colors.gray[1]};
  font-size: 1.125rem;
`;

export const Body = styled.div``;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
`;

export const Modal = styled(ModalBase)`
  max-width: 564px;
  width: 100%;
  box-sizing: border-box;
`;
